import { BellOffIcon } from 'lucide-react'

export default function NenhumaNotificacao() {
    return (
        <div className="mt-12 flex flex-col items-center justify-center gap-4">
            <BellOffIcon className="size-20 text-muted-foreground" />
            <span className="text-sm text-center text-muted-foreground">
                Nenhuma novidade por enquanto
            </span>
        </div>
    )
}
